/**
 * @name          slider
 * @version       1.0
 * @lastmodified  2015-10-26
 * @package       html-css-js
 * @subpackage    jQuery plugin
 * @author        JB, VI
 *
 * based on: http://jqueryboilerplate.com/
 */

;(function ($, window, document, undefined) {
	'use strict';

	var pluginName = 'slider',
		defaults = {
			contentSelector: '.slider__content',
			loadingClass: 'slider--loading',
			defaultConfig: {
				infiniteLoop: false,
				adaptiveHeight: true,
				swipeThreshold: 70,
				oneToOneTouch: false,
				controls: false
			}
		};

	// The actual plugin constructor
	function Plugin(element, options) {
		var self = this;
		self.$element = $(element);
		self.options = $.extend({}, defaults, options);
		self.$sliderContent = self.$element.find(self.options.contentSelector);
		self.init();
	}

	// methods
	var methods = {
		init: function () {
			// load slider initially
			this.loadSlider();
		},

		loadSlider: function () {
			var self = this;
			var config = self.options.defaultConfig;

			// define callback functions
			config.onSliderLoad = $.proxy(self.onSliderLoad, self);
			config.onSliderResizeBefore = $.proxy(self.onSliderResizeBefore, self);
			config.onSliderResizeAfter = $.proxy(self.onSliderResizeAfter, self);
			config.onSlideAfter = $.proxy(self.onSlideAfter, self);

			// configure auto mode
			self.isAutoModeActive = false;
			self.autoSlideInterval = self.$element.data('auto-slide') || 0;

			if (!isNaN(self.autoSlideInterval) && self.autoSlideInterval > 0) {
				config.infiniteLoop = true;
				config.onSlideBefore = $.proxy(self.onSlideBefore, self);

				self.$element.on('mouseenter.slider', function() {
					clearInterval(self.autoInterval);
				});
				self.$element.on('mouseleave.slider', function() {
					self.startAutoMode();
				});
			}

			// remove pager/dots if only a single item is configured
			config.pager = (self.$sliderContent.children('li').length > 1);

			// initially load slider
			self.slider = self.$sliderContent.bxSlider(config);
		},

		onSliderLoad: function() {
			var self = this;

			// init responsive image plugin
			self.$element.find('.picture--slider').responsiveImage({
				autoDpr: true
			});

			// start auto mode initially
			self.startAutoMode();

			// listen for object-fit polyfill ready event
			self.$element.on('objectfit.ready', 'img', function () {
				// recalculate height
				self.slider.recalculateHeight();
			});

			// listen for responsive image load event
			self.$element.find('.picture').on('load.source.responsiveImage', function () {
				// recalculate height
				self.slider.recalculateHeight();
			});

			// remove loading state
			self.$element.removeClass(self.options.loadingClass);
		},

		onSliderResizeBefore: function () {
			var self = this;

			// add loading state class
			self.$element.addClass(self.options.loadingClass);
		},

		onSliderResizeAfter: function () {
			var self = this;

			// remove loading state class
			self.$element.removeClass(self.options.loadingClass);
		},

		onSlideBefore: function () {
			var self = this;

			if (!self.isAutoModeActive) {
				clearInterval(self.autoInterval);
				self.autoSlideInterval = 0;
				self.$element.off('mouseenter.slider mouseleave.slider');
			} else {
				self.isAutoModeActive = false;
			}
		},

		onSlideAfter: function() {
			var self = this;

			self.$element.trigger('slide-after');
		},

		startAutoMode: function () {
			var self = this;

			if (self.autoSlideInterval > 0) {
				self.autoInterval = setInterval(function() {
					self.isAutoModeActive = true;
					self.slider.goToNextSlide();
				}, self.autoSlideInterval);
			}
		},

		destroy: function () {
			this.slider.destroySlider();
		}
	};

	// build
	$.extend(Plugin.prototype, methods);

	// A really lightweight plugin wrapper around the constructor,
	// preventing against multiple instantiations
	$.fn[pluginName] = function(options) {
		this.each(function() {
			if(!$.data(this, 'plugin_' + pluginName)) {
				$.data(this, 'plugin_' + pluginName, new Plugin(this, options));

				// trigger ready event on element
				$.triggerFailsafeEvent($(this), 'plugin_' + pluginName + '.ready');
			}
		});

		// trigger ready event globally
		if(this.length > 0) {
			$.triggerFailsafeEvent($(window), 'plugin_' + pluginName + '.ready_all');
		}

		return this;
	};

})(jQuery, window, document);
